module.exports = __webpack_public_path__ + "asset/img/courseCover.0e658c3d5a4a4c79f0271de442636236.png";